import { Box, styled } from '@mui/material';

export const CronJobsCRUDFormBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(4),
  gap: theme.spacing(4)
}));

export const CronJobsCRUDFormActionsBox = styled(Box)(() => ({
  display: 'flex',
  ml: 'auto'
}));

export const TasksCronJobsFormContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));
